import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

export const GameHighlights = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.highlights};
`;

export const HighlightsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: column;

    ${BaseStyle.Mixins.screenSizes.medium} {
        flex-direction: row;
    }
`;

export const Highlight = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle2}
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    flex-direction: column;
    flex: 1 1 0;

    ${BaseStyle.Mixins.screenSizes.medium} {
        max-width: 250px;
    }
`;

export const ThumbnailContainer = styled.div`
    display: flex;
    position: relative;

    svg {
        height: 36px;
        width: 36px;
        fill: ${({ theme }) => theme.Text.OppositeSurface.primary};
        position: absolute;
        bottom: 8px;
        left: 8px;
    }

    &:hover {
        cursor: pointer;
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        svg {
            height: 28px;
            width: 28px;
        }
    }
`;

export const ThumbnailImage = styled.img`
    max-width: 100%;

    ${BaseStyle.Mixins.screenSizes.medium} {
        max-height: 145px;
    }
`;

export const HighlightDescription = styled.span`
    ${BaseStyle.Mixins.fontStyles.desktop.date}
    color: ${({ theme }) => theme.Text.secondary};
`;
